import { Component } from "@angular/core";
import { CandidateDocumentDateComponent } from "../../features/candidate-document-metadata/metadata-wrapper-components/candidate-document-date.component";
import { NewUiFormlyDocumentDateComponent } from "./new-ui-formly-document-date.component";

@Component({
  selector: "app-formly-document-date",
  templateUrl: "./formly-document-date.component.html",
  imports: [CandidateDocumentDateComponent],
})
export class FormlyDocumentDateComponent extends NewUiFormlyDocumentDateComponent {}
